export default __webpack_public_path__ + "static/media/testing (1).136d7266.png";